module.exports = __webpack_public_path__ + "img/Ardunic Elements-25.51321cef.svg";